const en_master_storage = {
    "": "Storage Area",
    name: "Storage Area Name",
    add: "Add Storage Area",
    edit: "Edit Storage Area",

    error: {
        name: "Storage area name is required",
        create: "Failed to create storage area",
        delete: "Failed to delete storage area",
        edit: "Failed to update storage area",
    },

    success: {
        name: "Storage area name is required",
        create: "Storage area created successfully",
        delete: "Storage area deleted successfully",
        edit: "Storage area updated successfully",
    }
}

export default en_master_storage;